import { useEffect, useState } from "react";

import logoGirl from "../images/LogoCSM_girl.png";
import logoinsta from "../images/platform_logos/Instagram_Glyph_White.svg";

import { Link } from "react-router-dom";

import "../blocks/Header.css";

function Header() {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const hero = document.querySelector(".hero-image-container");
    if (!hero || !("IntersectionObserver" in window)) {
      setIsAtTop(window.scrollY <= 0);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsAtTop(entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <header className={`header${isAtTop ? " header--at-top" : ""}`}>
      <div className="header__container">
        {/* BRAND */}
        <div className="header__brand">
          <Link to="/" className="header__brand-link" aria-label="Inicio">
            <img
              className="header__brand-badge"
              src={logoGirl}
              alt="Carmen Supermarket"
              width="56"
              height="56"
              decoding="async"
              loading="eager"
            />
            <span
              className="header__brand-text"
              aria-label="Carmen Supermarket, Rock Band"
            >
              <span className="header__brand-title">Carmen Supermarket</span>
              <span className="header__brand-sep" aria-hidden="true">
                {" "}
                —{" "}
              </span>
              <span className="header__brand-subtitle">Rock Band</span>
            </span>
          </Link>
        </div>

        {/* MENÚ */}
        <div className="header__menu">
          <ul className="header__menu-list">
            {/* <li className="header__menu-list-item">
              <Link
                className="header__menu-list-item-link"
                to="/#music-platforms"
              >
                Escúchanos en tu plataforma preferida
              </Link>
            </li> */}
            <li className="header__menu-list-item">
              <Link className="header__menu-list-item-link" to="/#contact">
                Contacta
              </Link>
            </li>
            <li className="header__menu-list-item">
              <a
                className="header__menu-social"
                href="https://www.instagram.com/carmensupermarket"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram de Carmen Supermarket"
              >
                <img
                  className="header__logo-image-insta"
                  src={logoinsta}
                  alt="Instagram"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
